import { useState } from 'react';

export function useSelection<T>(): [
  T[],
  T[],
  (isChecked: boolean, rowId: T) => void,
  (isChecked: boolean, rows: T[]) => void,
  () => void,
  () => void,
] {
  const [selectedRows, setSelectedRows] = useState<T[]>([]);
  const [previousSelectedRows, setPreviousSelectedRows] = useState<T[]>([]);

  const toggleSelection = (isChecked: boolean, rowId: T): void => {
    if (isChecked) {
      setSelectedRows(prevSelectedRows => [...prevSelectedRows, rowId]);
      setPreviousSelectedRows(prevSelectedRows => [...prevSelectedRows, rowId]);
    } else {
      setSelectedRows(prevSelectedRows =>
        prevSelectedRows.filter(selectedRow => selectedRow !== rowId),
      );
      setPreviousSelectedRows(prevSelectedRows =>
        prevSelectedRows.filter(selectedRow => selectedRow !== rowId),
      );
    }
  };

  const handleClearSelected = (): void => {
    setSelectedRows([]);
    setPreviousSelectedRows([]);
  };

  const handlePreviousRowSelection = () => {
    setSelectedRows(previousSelectedRows);
  };

  const toggleAllSelection = (isChecked: boolean, rows: T[]): void => {
    if (isChecked) {
      const rowsWithoutDuplicates = rows.filter(
        row => !selectedRows.includes(row),
      );

      setPreviousSelectedRows(selectedRows);
      setSelectedRows(previous => [...previous, ...rowsWithoutDuplicates]);
      return;
    }

    setSelectedRows(previousRows =>
      previousRows.filter(row => !rows.includes(row)),
    );
  };

  return [
    selectedRows,
    previousSelectedRows,
    toggleSelection,
    toggleAllSelection,
    handleClearSelected,
    handlePreviousRowSelection,
  ];
}
